import MobileHeader from './MobileHeader';

export default function MobilePage({ children, contentClassName = '', noHeader = false }) {
  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      {!noHeader && <MobileHeader />}
      <main className={`flex-1 overflow-y-auto px-4 lg:px-8 pb-nav md:pb-8 md:pt-6 ${contentClassName}`}>
        {children}
      </main>
    </div>
  );
}
